
import axios from "axios";

import { IP } from "utils/Host";

// zmiana procesora w grupie z poziomu technologia stage
export function dropStageDodajPrzerweGold(procesorId,dropDate,time,zablokowany,refreshGantAll,procesory) {

// id = procesor id
 let proces_nazwa_id = procesory.find(x=> x.id == procesorId).grupa
  
  axios
  .get(IP + "API_0018_gant_procedura_dodaj_przerwe_gold/"+procesorId+"/"+dropDate+"/"+time+"/"+zablokowany+"/"+proces_nazwa_id+"/" + sessionStorage.getItem("token"))
    .then((res) => {
refreshGantAll()

    })
}

//   +"/" + sessionStorage.getItem("token")

